export default {"src":"/_next/static/media/booking-fast.2c56d5dd.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};